"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageTransferLabel = void 0;
const getPackageTransferLabel = (pkg) => {
    if (pkg.airport_transfer && pkg.course_transfer) {
        return "All Transfers";
    }
    else {
        if (pkg.airport_transfer) {
            return "All Airport Transfers";
        }
        else if (pkg.course_transfer) {
            return "All Golf Transfers";
        }
    }
    return "";
};
exports.getPackageTransferLabel = getPackageTransferLabel;
